import 'bulma/css/bulma.min.css';
import React from 'react';

interface Props {
    name: string;
}


function ApplicationnName({ name }: Props) {

    const nameStyle = {
        div: {
            marginTop: "25px"
        }
    };

    return (
        <div className="navbar-content has-text-centered" style={nameStyle.div}>
            <div className="is-size-5 has-text-weight-bold has-text-link">
                <span>{name}</span>
            </div>
        </div>
    );
}

export default ApplicationnName;